import { Component, EventEmitter, Input, Output, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { of as observableOf } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
// import { ModalDirective } from 'ngx-bootstrap/modal';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-communication-logs',
  templateUrl: './communication-logs.component.html',
  styleUrls: ['./communication-logs.component.scss']
})
export class CommunicationLogsComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() communicationData: any;
  @Input() isReminderMode: boolean = false;
  initialLoad: boolean = true;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();

  // @ViewChild('noteDialog')
  // noteDialog!: ModalDirective;

  @ViewChild('followUpModal')
  followUpModal!: TemplateRef<any>;

  modalRef: NgbModalRef | null = null;

  btnLoading = false;

  // Follow-up related properties
  leadsFollowList: any[] = [];
  followupLoading: boolean = false;

  LeadLogs: any[] = [];
  totalRows = 0;
  currentPage = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];

  curentNote: any;

  btnLoading3: boolean = false;

  cuurentSelectedData: any;
  reloading: boolean = false;

  displayedColumns: string[] = [
    "communication_type",
    "date_of_communication",
    "time_of_communication",
    "status",
    "callDuration",
    "note"];


  constructor(
    private toast: ToastrService,
    private api: LeadService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private tracker: TrackingService

  ) { }

  ngAfterViewInit() {
    this.loadData();
    this.tracker.track("View", "Communication Logs", `Viewed communication logs for lead ID: ${this.communicationData?.lead_id}`);

  }



  loadData() {
    this.reloading = true;
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            console.log("client_id", this.localStorage.getClientId())
            const data = {
              "where": {
                "client_id": this.localStorage.getClientId(),
                "lead_id": this.communicationData.lead_id,
                "center_id": this.localStorage.getCenterId()
              },
              "filter": null,
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"communication_history_log\".\"createdAt\"",
                "dir": "DESC"
              }
            }

            return this.api.getCommunicationHisLogs(data)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            this.reloading = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            console.log("data communication log", data)
            this.reloading = false;
            this.dataSource = new MatTableDataSource<any>(data?.rows || []);
          },
          error: (e) => {
            this.reloading = false;
            this.initialLoad = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      console.error(e);
    }
  }

  updateData() {
    try {
      console.log("client_id", this.localStorage.getClientId());
      const data = {
        "where": {
          "client_id": this.localStorage.getClientId(),
          "lead_id": this.communicationData.lead_id,
          "center_id": this.localStorage.getCenterId()
        },
        "filter": null,
        "page": this.paginator.pageIndex * this.paginator.pageSize,
        "limit": this.paginator.pageSize,
        "order": {
          "col": "\"communication_history_log\".\"createdAt\"",
          "dir": "DESC"
        }
      };

      this.api.getCommunicationHisLogs(data)
        .pipe(
          catchError(() => observableOf(null)),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            console.log("data communication log", data);
            this.dataSource = new MatTableDataSource<any>(data?.rows || []);
            this.btnLoading3 = false;

            // close only note dialog

            this.modalRef?.close();
            // this.noteDialog.hide();

            this.toast.success('Note updated successfully');
          },
          error: (e) => {
            this.initialLoad = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
          }
        });
    } catch (e) {
      this.initialLoad = false;
      console.error(e);
    }
  }




  formatDate(time: string): string {
    const date = new Date(time);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',  // "long" for full month name (e.g., "August"), "short" for abbreviated (e.g., "Aug")
      day: 'numeric'  // "numeric" for day of the month as a number
    };
    return date.toLocaleDateString('en-US', options);

  }

  closeModal() {
    this.close.emit();
  }


  openNoteDialog(element: any, note: any, data: any) {
    this.curentNote = note;
    this.cuurentSelectedData = data;
    this.modalRef = this.modalService.open(element, { size: 'md', scrollable: true, centered: true });
  }

  updateNote() {

    console.log("update note", this.curentNote)
    console.log("update note", this.cuurentSelectedData)
    this.btnLoading3 = true;
    const payload = {
      "note": this.curentNote,
      "id": this.cuurentSelectedData.id,
      "lead_id": this.communicationData.lead_id
    }
    this.api.UpdateCommunicationHisLog(payload).subscribe({
      next: (res: any) => {
        this.tracker.track(
  "Update",
  "Communication Logs",
  `Updated note for communication ID: ${this.cuurentSelectedData?.id} on lead ID: ${this.communicationData?.lead_id}`
);
        this.updateData();
      },
      error: (err: any) => {

        this.toast.error('Failed to update note');
        this.modalService.dismissAll();
        this.btnLoading3 = false;
      }
    });
  }


  reloadTable() {
    this.initialLoad = true;
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
    this.tracker.track(
  "Reload",
  "Communication Logs",
  `Reloaded communication logs for lead ID: ${this.communicationData?.lead_id}`
);

    this.loadData();
  }

  openModal(modal: any) {
    this.modalService.open(modal, { size: 'lg', scrollable: true, centered: true });
  }

  // Follow-up related methods
  openFollowUpModal() {
    this.getFollowUps(this.communicationData.lead_id);
    this.modalService.open(this.followUpModal, { size: 'xl', backdrop: 'static', centered: true });
    this.tracker.track("View", "Follow-ups", `Viewed follow-ups for lead ID: ${this.communicationData?.lead_id}`);
  }

  getFollowUps(leadId: any) {
    this.followupLoading = true;
    const param = {
      lead_id: leadId,
      client_id: this.localStorage.getClientId(),
      center_id: this.localStorage.getCenterId()
    };
    
    this.api.getLeadsFollowup(param).subscribe({
      next: (res) => {
        this.followupLoading = false;
        this.leadsFollowList = res || [];
        console.log('Follow-ups loaded:', this.leadsFollowList);
      },
      error: (err) => {
        this.followupLoading = false;
        this.toast.error('Error loading follow-ups');
        console.error('Error loading follow-ups:', err);
      }
    });
  }


}
